import React from 'react';

function ContactSignUp() {
    return (
        <>
            <div className='py-5 px-6 whiteBox is-flex is-flex-direction-column is-justify-content-center is-justify-content-center'>
                <h3 className='py-2 m-0'>Try Nudgemail today</h3>
                <p className='pb-0 mb-0'>Get started with a free account when you sign up to experiment with Nudgemail.</p>
                <div className="mt-5">
                    <a href="/sign-up" className="mr-4 button">Get started</a>
                </div>
            </div>
        </>
    )
}

export default ContactSignUp;